import { makeAutoObservable } from 'mobx';
import { getUserCoupon, getCouponTask, getUsercouponCount } from '../api/xt-coupon';

type TaskItemType = 'DEPOSIT_TOTAL_DEPOSIT' | 'FUTURES_FIRST_COPY_TRADE' | 'FUTURES_FIRST_GRID_TRADE' | 'FUTURES_FIRST_TRADE' | 'FUTURES_FIRST_TRANSFER' | 'FUTURES_INVITE_FRIEND_TRADE' | 'FUTURES_N_DAY_TRADE_VOLUME' |  'FUTURES_SINGLE_TRADE' | 'FUTURES_TOTAL_TRADE' | 'THRESHOLD_FREE';

type TaskType = 'DEPOSIT_MONEY' | 'FUTURES'| 'INVITE';

type UserTaskStatus = 'COMPLETED' | 'EXPIRED' | 'FORBIDDEN' | 'RECEIVED';

type UserCouponStatus = 'INIT' | 'ACTIVE' | 'USED' | 'EXPIRE' | 'FORBIDDEN';

type CouponType = 'FUTURE_EXPERIENCE';

type IUserCoupon = {
  couponDistributeRecordId: number,
  couponExpireTime?: number,
  couponType: CouponType,
  currency: string,
  currencyId?: number,
  distributeAmount: number,
  lever?: number,
  symbol?: string,
  symbolId?: number,
  userCouponStatus: UserCouponStatus
}

type ITask = {
  couponType: CouponType;
  currency: string,
  currencyId: number,
  distributeAmount: number,
  taskCreatedTime: number,
  taskExpireTime: number,
  taskItemType: TaskItemType,
  taskItemTypeCondition: string,
  taskProgressValue: number,
  taskType: TaskType,
  userTaskStatus: UserTaskStatus
}

export default class Coupon {
  loading = false;
  userCoupon = {};
  userTask: ITask;
  couponTask: ITask;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    // this.userCoupon = [
    //   {
    //     couponDistributeRecordId: 0,
    //     couponExpireTime: 0,
    //     couponType: 'FUTURE_EXPERIENCE',
    //     currency: '',
    //     currencyId: 0,
    //     distributeAmount: 0,
    //     lever: 0,
    //     symbol: '',
    //     symbolId: 0,
    //     userCouponStatus: 'INIT'
    //   }
    // ]
  }


  async fetchUserCoupon(data) {
    this.loading = true;
    const result = await getUserCoupon({params: data});
    this.loading = false;
    this.userCoupon = result;
    return result;
  }

  setCouponTask(data) {
    this.couponTask = data;
  }

  async fetchCouponTask(data) {
    const result = await getCouponTask(data);
    this.setCouponTask(result);
    return result;
  }

  async fetchUsercouponCount() {
    const result = await getUsercouponCount();
    return result;
  }
}